import BlockHeroText from './BlockHeroText';
export default BlockHeroText;
